import { render, staticRenderFns } from "./CheckBalance.vue?vue&type=template&id=390a9bbf&scoped=true&"
import script from "./CheckBalance.vue?vue&type=script&lang=js&"
export * from "./CheckBalance.vue?vue&type=script&lang=js&"
import style0 from "./CheckBalance.vue?vue&type=style&index=0&id=390a9bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390a9bbf",
  null
  
)

export default component.exports